import { variableColors } from '@y42/model';

const imagesPath = '/assets/images/';

export const orchestrationDiagramConfig = {
  defaultScale: 0.7,
  node: {
    textLength: 35,
    colors: {
      light: {
        default: variableColors.white,
        highlighted: '#1b1b52',
        deleted: variableColors.gray400,
      },
      dark: {
        default: variableColors.gray200Dark,
        highlighted: variableColors.gray1200Dark,
        deleted: variableColors.gray400Dark,
      },
      duplicate: '#ea9d13',
      active: variableColors.green500,
      disabled: variableColors.gray600,
      filtered: variableColors.lime300,
      deletedSource: variableColors.gray400,
      statusFiltered: {
        pending: variableColors.blue800Dark,
        valid: variableColors.green400,
        invalid: '#F36331',
      },
    },
  },
  port: {
    light: {
      fill: variableColors.gray300,
    },
    dark: {
      fill: variableColors.gray200Dark,
    },
  },
  mainPanel: {
    light: variableColors.white,
    dark: variableColors.gray200Dark,
  },
  link: {
    light: {
      default: variableColors.gray300,
      highlighted: '#1b1b52',
    },
    dark: {
      default: variableColors.gray400Dark,
      highlighted: variableColors.gray1200Dark,
    },
    colors: {
      primary: variableColors.gray300,
      hover: '#1b1b52',
      active: variableColors.green500,
      success: variableColors.green400,
      fail: variableColors.orange500,
    },
  },
  tooltip: {
    duplicateText: 'Duplicate Node',
    colors: {
      stroke: variableColors.gray800,
      fill: variableColors.white,
    },
  },
  contextMenu: {
    colors: {
      stroke: '#486275',
    },
  },
  colors: {
    white: variableColors.white,
    primary: '#1b1b52',
    lightgrey: variableColors.gray300,
    lighterGray: variableColors.purple,
    shadowColor: '#0000001A',
    transparent: 'transparent',
    goodText: variableColors.green400,
    badText: '#f36331',
  },
  font: {
    family: 'Helvetica Neue',
    style: 'Normal',
    weight: {
      normal: 'Normal',
      bold: 'Bold',
    },
    size: {
      regular: '14px',
      big: '16px',
    },
    color: {
      light: '#1b1b52',
      disabledLight: variableColors.gray600,
      disabledDark: variableColors.gray900,
      dark: variableColors.white,
    },
  },
  icons: {
    squareIcon: `${imagesPath}datablend/Square.svg`,
    arrowIcon: `${imagesPath}datablend/Arrow.svg`,
    deleteIcon: `${imagesPath}datablend/delete.svg`,
  },
  filteredOutOpacity: 0.2,
  defaultOpacity: 1,
};
